module.exports = __webpack_public_path__ + "img/compostingToiletDiagramText.720d9d90.png";